/**
 * Chemin de l'ecran de tracabilite du stock.
 *
 * Module **pur**, importe par l'ecran, le registre de navigation et les liens
 * qui y menent (palette de recherche, fiche de compte) : ecrire `/stock?code=`
 * en clair a chaque endroit le ferait diverger sans qu'aucun test ne tombe.
 */

export const STOCK_PATH = '/stock';

/** Nom du parametre de requete qui porte la recherche (`/stock?code=`). */
export const STOCK_CODE_PARAM = 'code';

/**
 * Adresse de l'ecran, ouvert sur une recherche. `code` est un code de lot ou
 * l'identifiant d'un lot, d'un tirage ou d'un biberon, sans autre forme imposee
 * ici : c'est le serveur qui en juge.
 */
export const stockSearchPath = (code: string): string =>
  `${STOCK_PATH}?${STOCK_CODE_PARAM}=${encodeURIComponent(code)}`;
